import { useEffect, useState } from "react";
import { fetchServerIp } from "../../../api/requests/integration-requests";

// Değer sunucu yapılandırmasından gelir, oturum boyunca değişmez: her modal
// açılışında yeniden istek atmamak için modül seviyesinde tek sefer tutulur.
let cachedRequest = null;

const loadServerIp = () => {
    if (!cachedRequest) {
        cachedRequest = fetchServerIp()
            .then((res) => res?.data?.ip || null)
            .catch(() => null);
    }
    return cachedRequest;
};

/** Sunucu çıkış IP'si; tanımsızsa veya istek başarısızsa null. */
export const useServerIp = () => {
    const [ip, setIp] = useState(null);

    useEffect(() => {
        let alive = true;
        loadServerIp().then((value) => {
            if (alive) setIp(value);
        });
        return () => {
            alive = false;
        };
    }, []);

    return ip;
};
